import styled from 'styled-components';

/**
 * Stacks the reframe modal's tab panels in one grid cell, so the modal is as
 * tall as its tallest panel (Framing) whichever tab is showing — switching
 * tabs never resizes the centred dialog.
 */
export const TabPanels = styled.div`
  display: grid;
  width: 100%;

  > * {
    grid-area: 1 / 1;
  }
`;

/** Hidden panels keep their space but can't be seen, clicked or focused. */
export const TabPanel = styled.div<{ $hidden: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  width: 100%;
  visibility: ${({ $hidden }) => ($hidden ? 'hidden' : 'visible')};
`;
